/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "../../../component/button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { withTranslation } from "react-i18next";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";

class Confirmation extends Component {
  componentDidMount() {}

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };
  render() {
    return (
      <div>
        <Dialog
          disableScrollLock={true}
          PaperComponent={this.draggableDialogPaper}
          aria-labelledby="customized-dialog-title"
          open={this.props.confirmationDialog}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {this.props.t("CONFIRM_REMOVE")}
          </DialogTitle>
          <DialogContent dividers>
            {this.props.t("REMOVE_SOLUTION_CONFIRMATION_MESSAGE")}
          </DialogContent>

          <DialogActions>
            <Button
              onClick={(event) => this.props.handleConfirmation(false)}
              color="primary"
            >
              {this.props.t("NO")}
            </Button>
            <Button
              onClick={(event) => this.props.handleConfirmation(true)}
              color="primary"
            >
              {this.props.t("YES")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withTranslation("translations")(Confirmation);
